import { render, staticRenderFns } from "./receivelog.vue?vue&type=template&id=99b73b34&scoped=true&"
import script from "./receivelog.vue?vue&type=script&lang=js&"
export * from "./receivelog.vue?vue&type=script&lang=js&"
import style0 from "./receivelog.vue?vue&type=style&index=0&id=99b73b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b73b34",
  null
  
)

export default component.exports